import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { IState } from '../../shared/models/state';
import { Actions } from '@ngrx/effects';
import { GET_BILLING_INFORMATION_SUCCESS, GetBillingInformationAction } from './billing.action';

@Injectable()
export class BillingResolve implements Resolve<any> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve() {
    this.store.dispatch(new GetBillingInformationAction());
    return this.action$.ofType(GET_BILLING_INFORMATION_SUCCESS).take(1);
  }
}
